module.exports = {
  DESKTOP: 'DESKTOP',
  MOBILE: 'PHONE',
  MOBILE_NAV_BREAKPOINT: 1024,
};
